import { TabPanel, TabView } from "primereact/tabview";

import { LoadingSpinner } from "../../components/LoadingSpinner";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { useGetCompanyDashboardUrlQuery } from "../../store/queries/metrics";

export function RevenueDashboard() {
  useDocumentTitle("Revenue Dashboard");

  const { data, isLoading } = useGetCompanyDashboardUrlQuery();

  return (
    <TabView className="w-full">
      <TabPanel header="Revenue Dashboard">
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <div
            style={{
              width: "100%",
              height: "1300px",
              padding: "0",
              margin: "0",
            }}
          >
            {data?.iframeUrl && (
              <iframe
                src={data.iframeUrl}
                frameBorder="0"
                width="1400"
                height="1300"
                title="Revenue Dashboard"
              />
            )}
          </div>
        )}
      </TabPanel>
    </TabView>
  );
}
